import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableContact extends Layout {
	sourceContacts: DataSource;
	tableContacts: Table;
}
